import React, { FC } from 'react'
//@ts-ignore`
import DisableableDropdownField from 'shared/FormFields/DisableableDropdownField'
//@ts-ignore`
import { withLookups, LookupType } from 'shared'
import { AccSearchAccTypesProps } from '../components.type'

const obtainAccTypes = (accTypes = []) =>
  accTypes.map((accType) => ({
    id: accType.ID,
    title: accType.Title,
  }))

const makeOptions = (choices: Array<{ id: number; title: string }>) =>
  choices.map((choice, index) => ({
    key: index.toString(),
    text: choice.title,
    value: choice.id,
  }))

const AccSearchAccTypes: FC<AccSearchAccTypesProps> = ({ selector, accTypes }) => {
  const choices = obtainAccTypes(accTypes)

  if (choices === undefined || choices === null) {
    return null
  }

  const options = makeOptions(choices)

  return (
    <DisableableDropdownField
      name="accTypes"
      options={options}
      disabilityCheckboxName="accTypesDisabled"
      dropdownsShareOfWidth={14}
      disabled={selector}
    />
  )
}

//@ts-ignore`
export default withLookups({
  type: LookupType.Search,
  query: ['AccountTypes as accTypes'],
})(AccSearchAccTypes)
